export enum Device {
  BROWSER = 'Browser',
  MOBILE = 'Mobile'
}
